const firebaseConfig = {
    apiKey: "AIzaSyDz-akre74aWiyyZEN340xInK4cJTAPBew",
    authDomain: "bike-sales-4dae1.firebaseapp.com",
    projectId: "bike-sales-4dae1",
    storageBucket: "bike-sales-4dae1.appspot.com",
    messagingSenderId: "177122823489",
    appId: "1:177122823489:web:bed9f3ee0a0df9f12765c0"

};
export default firebaseConfig;